import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import {NgModule, PLATFORM_ID} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule
} from '@ngx-translate/core';
import 'rxjs/observable/of';
import { AppComponent } from './app.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {CacheModule} from '@ngx-cache/core';
import {CacheLoader} from '@ngx-cache/core';
import {CACHE} from '@ngx-cache/core';
import {CacheStaticLoader} from '@ngx-cache/core';
import {BrowserCacheModule, LocalStorageCacheService} from '@ngx-cache/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MyMissingTranslationService} from './shared/services/my-missing-translation.service';
import {CommonModule} from '@angular/common';
import {SharedModule} from './shared/shared.module';
import {CookieModule} from 'ngx-cookie';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

export function cacheFactory(): CacheLoader {
    return new CacheStaticLoader({
        key: 'NGX_CACHE',
        lifeSpan: {
            'expiry': Number.MAX_VALUE,
            'TTL':  Number.MAX_VALUE
        }
    });
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserTransferStateModule,
    SharedModule,
    HttpClientModule,
    CookieModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      },
      missingTranslationHandler: {provide: MissingTranslationHandler, useClass: MyMissingTranslationService},
      useDefaultLang: false
    }),
    CacheModule.forRoot({
        provide: CacheLoader,
        useFactory: (cacheFactory)
    }),
    BrowserCacheModule.forRoot([{
      provide: CACHE,
      useClass: LocalStorageCacheService,
      deps: [PLATFORM_ID]
    }]),
    BrowserAnimationsModule,
    AppRoutingModule,
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
